import { cn } from '@/shared/utils/cn';

/**
 * Fuente única de los estilos del buscador. El del navbar es el patrón oficial
 * del sitio, así que todas las superficies —filtros, glosario, hero de cursos—
 * consumen estas constantes en vez de replicarlas y divergir.
 */

export const SEARCH_FIELD_SECONDARY_ACTION_CLASS =
  'transition duration-adipa-fast ease-out motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-adipa-primary hover:border-adipa-border-strong hover:bg-adipa-surface-lavender hover:text-adipa-primary active:bg-adipa-surface-lavender';

/**
 * El padding derecho depende de cuántas acciones hay a la derecha del input:
 * solo enviar, o limpiar + enviar.
 */
export const searchFieldInputClass = (options: {
  hasQuery: boolean;
  hasTextSubmit?: boolean;
}): string =>
  cn(
    'header-search-input rounded-adipa-lg border-adipa-border bg-adipa-surface h-11 w-full border pl-4',
    options.hasTextSubmit
      ? options.hasQuery
        ? 'pr-40'
        : 'pr-32'
      : options.hasQuery
        ? 'pr-24'
        : 'pr-14',
    'text-adipa-text-primary placeholder:text-adipa-console-text-muted text-sm font-medium placeholder:opacity-75',
    'duration-adipa-base transition ease-in-out',
    'focus-visible:border-adipa-secondary focus-visible:bg-adipa-surface focus-visible:ring-adipa-secondary/30 focus-visible:outline-none focus-visible:ring-2',
  );

export const searchFieldClearButtonClass = (options: { hasTextSubmit?: boolean } = {}): string =>
  cn(
    'global-header-search-icon-button rounded-adipa-md group absolute inline-flex h-9 w-9 items-center justify-center',
    options.hasTextSubmit ? 'right-[7.25rem]' : 'right-11',
    'border-adipa-border bg-adipa-surface text-adipa-text-secondary border',
    'cursor-pointer active:scale-95',
    SEARCH_FIELD_SECONDARY_ACTION_CLASS,
  );

export const searchFieldSubmitButtonClass = (options: { hasTextSubmit?: boolean } = {}): string =>
  cn(
    'global-header-search-icon-button rounded-adipa-md bg-adipa-secondary text-adipa-primary-foreground group absolute right-1 inline-flex h-9 items-center justify-center',
    options.hasTextSubmit ? 'gap-1.5 px-4 text-sm font-semibold' : 'w-9',
    'shadow-adipa-card duration-adipa-fast cursor-pointer transition ease-out motion-reduce:transition-none',
    'hover:bg-adipa-primary hover:text-adipa-primary-foreground hover:shadow-adipa-console-panel active:bg-adipa-primary-hover active:scale-95',
    'focus-visible:outline-adipa-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
  );
